<template>
    <notifications :group="group" position="top right" style="width: 100%;">
        <template slot="body" slot-scope="props">
            <div class="notification-layout">
                <InfoBox
                    icon-width="28"
                    :icon="props.item.data.icon"
                    :text="props.item.text"
                ></InfoBox>
            </div>
        </template>
    </notifications>
</template>

<script>
import InfoBox from "@/app/mobile/ui/InfoBox";
export default {
    name: "MobileToast",
    components: { InfoBox },
    props: ["group"],
};
</script>

<style scoped></style>
